export const techText = {
    html: [
        "html",
        "HyperText Markup Language is the standard markup language for creating web pages and web applications. ",
    ],
    css: [
        "css",
        "Cascading Style Sheets is a style sheet language used for describing the presentation of a document written in a markup language like HTML.",
    ],
    ts: ["ts", "TypeScript er et superset av JavaScript som legger til statisk typing og object-oriented programming."],
    js: [
        "js",
        "JavaScript is a high-level, dynamic, untyped, and interpreted programming language. It has been standardized in the ECMAScript language specification.",
    ],
    react: ["react", "React er et JavaScript-bibliotek for å bygge brukergrensesnitt."],
    d3: [
        "d3",
        "D3.js is a JavaScript library for manipulating documents based on data. D3 helps you bring data to life using HTML, SVG, and CSS.",
    ],
    vue: ["vue", "Vue.js er et JavaScript-bibliotek for å bygge brukergrensesnitt."],
    flutter: [
        "flutter",
        "Flutter is Google’s UI toolkit for building beautiful, natively compiled applications for mobile, web, and desktop from a single codebase.",
    ],
    node: ["node", "Node.js er et JavaScript-bibliotek for å bygge brukergrensesnitt."],
    prettier: [
        "prettier",
        "Prettier is an opinionated code formatter. It enforces a consistent style by parsing your code and re-printing it with its own rules that take the maximum line length into account, wrapping code when necessary.",
    ],
    jest: ["jest", "Jest is a delightful JavaScript Testing Framework with a focus on simplicity."],
    electron: [
        "electron",
        "Electron is a framework for creating native applications with web technologies like JavaScript, HTML, and CSS.",
    ],
    python: [
        "python",
        "Python is an interpreted, high-level, general-purpose programming language. Created by Guido van Rossum and first released in 1991, Python's design philosophy emphasizes code readability with its notable use of significant whitespace.",
    ],
    java: [
        "java",
        "Java is a general-purpose programming language that is class-based, object-oriented, and designed to have as few implementation dependencies as possible. It is intended to let application developers write once, run anywhere (WORA), meaning that compiled Java code can run on all platforms that support Java without the need for recompilation. Java applications are typically compiled to bytecode that can run on any Java virtual machine (JVM) regardless of the underlying computer architecture. The syntax in Java is similar to C and C++, but has fewer low-level facilities than either of them. As of 2019, Java was one of the most popular programming languages in use according to GitHub, particularly for client-server web applications, with a reported 9 million developers.",
    ],
    postgresql: [
        "postgresql",
        "PostgreSQL is a powerful, open source object-relational database system with over 30 years of active development that has earned it a strong reputation for reliability, feature robustness, and performance.",
    ],
    cSharp: [
        "cSharp",
        "C# is a general-purpose, multi-paradigm programming language encompassing strong typing, lexically scoped, imperative, declarative, functional, generic, object-oriented (class-based), and component-oriented programming disciplines.",
    ],
    kotlin: [
        "kotlin",
        "Kotlin is a cross-platform, statically typed, general-purpose programming language with type inference. Kotlin is designed to interoperate fully with Java, and the JVM version of its standard library depends on the Java Class Library, but type inference allows its syntax to be more concise. Kotlin mainly targets the JVM, but also compiles to JavaScript or native code (via LLVM); e.g., for native iOS apps sharing business logic with Android apps.",
    ],
    git: ["git", "Git is a distributed version-control system for tracking changes in source code during software development."],
    intellij: [
        "intellij",
        "IntelliJ IDEA is an integrated development environment (IDE) written in Java for developing computer software. It is developed by JetBrains (formerly known as IntelliJ), and is available as an Apache 2 Licensed community edition, and in a proprietary commercial edition.",
    ],
    vscode: [
        "vscode",
        "Visual Studio Code is a source-code editor developed by Microsoft for Windows, Linux and macOS. Features include support for debugging, syntax highlighting, intelligent code completion, snippets, code refactoring, and embedded Git. Users can change the theme, keyboard shortcuts, preferences, and install extensions that add additional functionality.",
    ],
    androidStudio: [
        "androidStudio",
        "Android Studio is the official integrated development environment (IDE) for Google's Android operating system, built on JetBrains' IntelliJ IDEA software and designed specifically for Android development. It is available for download on Windows, macOS and Linux based operating systems.",
    ],
    pycharm: [
        "pycharm",
        "PyCharm is an integrated development environment (IDE) used in computer programming, specifically for the Python language. It is developed by the Czech company JetBrains. It provides code analysis, a graphical debugger, an integrated unit tester, integration with version control systems (VCSes), and supports web development with Django as well as data science with Anaconda.",
    ],
    docker: ["docker", "Docker is a set of platform as a service (PaaS) products that use OS-level virtualization to deliver software in packages called containers."],
    unity: [
        "unity",
        "Unity is a cross-platform game engine developed by Unity Technologies, first announced and released in June 2005 at Apple Inc.'s Worldwide Developers Conference as a Mac OS X-exclusive game engine. As of 2018, the engine had been extended to support more than 25 platforms. The engine can be used to create three-dimensional, two-dimensional, virtual reality, and augmented reality games, as well as simulations and other experiences.",
    ],
};
